import {Component, OnInit, Output, Injectable} from '@angular/core';
import {CasesForm} from '../models/data-model';
import {Subscription} from 'rxjs/Subscription';
import {Router, ActivatedRoute} from '@angular/router';
import {Observable} from 'rxjs/Observable';
import {CaseService} from '../services/case.service';
import * as moment from 'moment';
import {AccordionModule} from 'primeng/accordion';
import {Location} from '@angular/common';
import {GlobalDataService} from '../../housekeeping/services/global-data.service';
declare var jQuery:any;
@Component({
    selector: 'app-detail',
    templateUrl: '../views/detail.component.html',
    styleUrls: ['../css/detail.component.css']
})
export class DetailComponent implements OnInit {
    public caseActivitydesc = "";
    public caseActivityid = "";
    public userTZ = '';
    public caseno: any;
    //public userId = localStorage.getItem('userId');
    public userId = sessionStorage.getItem('userId');
    public make = "";
    public model="";
    public showcaseActivities:boolean=false;
    public caseLogDetails: any;
    public showcaseLogDetails: boolean = true;
    public showError:boolean = false;
    public showerrorMess = "";
    public casesForm = new CasesForm ("","","","",{},{},{},{
                id: null,
                companyName: "",
                firstName: "",
                lastName: "",
                phone: "",
                phoneTimeToCall: "",
                mobile: "",
                mobileTimeToCall: "",
                email: "",
                addressId: {
                    id: null,
                    address1: "",
                    address2: "",
                    city: "",
                    postalCode: "",
                    stateId: {
                        id: null,
                        stateCode: "",
                        name: ""
                    },
                    countryId: {
                        id: null,
                        code: "",
                        name: ""
                    }
                },optedIn: null,
                  deleted: null,
                 dateSynced: null, 
                 userId:null,
                assignedTo: {
                id: null,
                userName: "",
                firstName: "",
                lastName: ""
            }, dealerId: {
                id: "",
                superDealerCode: "",
                name: "",
                globalCode: "",
                localCode: "",
                regionCode: "",
                countryCode: ""
            }, 
            dateEntered: "",
            createdBy: {},
            dateModified: "",   
            modifiedBy: {},
            vehicles: [{}]        
    },{},{},{},{},{},{},{},"","",new Date(),{},new Date(),{},new Date(),{},"","",[{}]);
    

    constructor(public _router: Router, public _caseService: CaseService, public activeroute: ActivatedRoute, private location: Location, private _globalService: GlobalDataService) {}

    ngOnInit() {
        window.scrollTo(0, 0);
        this.userTZ = this._globalService.USER_TZ;
        this.activeroute.params.subscribe(
            params => {
                if (Object.keys(params).length != 0) {
                    this.caseno = params.id;
                    this.casesForm.id = this.caseno;
                    this.getCaseDetails()
                }
            })
    }
    /**
     * @author Pradeep   
     * @description redirect to cases edit page
     */
    editCase(caseId) {
        this._router.navigate(['cases/edit/' + caseId])
    }

    /**
        * @author Pradeep
        * params CaseId,userId
        * @description get the lead data
        */
    getCaseDetails() {
        
        this._caseService.viewCaseDetails(this.caseno, this.userId, (result) => {
            this.casesForm = result;
                
            if (this.casesForm.activity  != null && this.casesForm.activity.length > 0)
                this.showcaseActivities = true;
            if (this.casesForm.typeId == null) {
                this.casesForm.typeId = {id: 0, code: "", description: "", active: true};
            }
            if (this.casesForm.statusId == null) {
                this.casesForm.statusId = {id: 0, code: "", description: "", active: true};
            }    
            if (this.casesForm.sourceId == null) {
                this.casesForm.sourceId = {id: 0, code: "", description: "", active: true};
            }
            if (this.casesForm.priorityId == null) {
                this.casesForm.priorityId = {id: 0, code: "", description: "", active: true};
            }
            if(this.casesForm.dealerId==null){
                this.casesForm.dealerId =  {id: "",superDealerCode: "",name: "",globalCode: "",localCode: "",regionCode: "",countryCode: ""}; 
            }
            if(this.casesForm.vehicleType==null){
                this.casesForm.vehicleType =  {id: null,make: "",model: ""}; 
            }
            if (this.casesForm.categoryId == null) {
                this.casesForm.categoryId = {id: 0, code: "", description: "", active: true};
            }    
            if (this.casesForm.subCategory1Id == null) {
                this.casesForm.subCategory1Id = {id: 0, code: "", description: "", active: true};
            }
            if (this.casesForm.subCategory2Id == null) {
                this.casesForm.subCategory2Id = {id: 0, code: "", description: "", active: true};
            }
            if (this.casesForm.assignedTo == null) {               
                this.casesForm.assignedTo = {id: null, userName: "", firstName: "", lastName: ""};
            }        
           /* if (result.individualId.vehicles.length > 0 ) {
                this.casesForm.individualId.vehicles = result.individualId.vehicles[0]
                if (result.individualId.vehicles.vehicleType != null) {
                    if (result.individualId.vehicles.vehicleType.make != 'undefined') {
                        this.make = result.individualId.vehicles.vehicleType.make
                        this.model = result.individualId.vehicles.vehicleType.model
                    }
                }
            }     */  
        })

    }
    getCaseLogDetails() {
        this.showcaseLogDetails = true;
        this._caseService.getCaseLogDetails(this.caseno, (result) => {
            this.caseLogDetails = result;
            if(this.caseLogDetails.length==0)
                this.showcaseLogDetails = false
            
        })   

    }
    /**
     * @author Pradeep   
     * @description edit the case activity data
     */
    editcaseActivities(id, desc) {
        this.caseActivitydesc = desc;
        this.caseActivityid = id;
    }
    
      /**
     * @author Pradeep   
     * @description delete the case activity data
     */
    deletecaseActivities(id,desc) {  
      this._caseService.deletCaseActivities(id, (result) => {                              
          //console.log("***************"+result)
            if(result=="DELETED_SUCCESSFULLY"){
             this.getCaseDetails();  
             this.caseActivitydesc = "";
             this.caseActivityid = ""; 
            } else {
                this.showError = true;
                this.showerrorMess = "Something went wrong !!"
            }
        })        
       
    }
    
     /**
     * @author Pradeep   
     * @description save the case activity data
     */
    saveCaseActivities() { 
        this.showError = false;
        if(this.caseActivitydesc == "") {
            this.showError = true;
            this.showerrorMess = "Please enter description."
        } else {
        this.showError = false;
       this._caseService.saveCaseActivities({"id": this.caseActivityid, "userId": this.userId, "notes": this.caseActivitydesc, "date": new Date(), "caseId": this.caseno, "activityTypeId": 1}, (result) => {                              
          // console.log("*************************"+result)
            if(result=="CASE_ACTIVITY_SAVED_SUCCESSFULLY"){
                this.caseActivitydesc = "";
                this.getCaseDetails();
                this.caseActivitydesc = "";
                this.caseActivityid = ""; 
                
            } else {
                this.showError = true;
                this.showerrorMess = "Something went wrong !!"
            }
        }) 
        }
    }
     /**
     * @author Pradeep   
     * @description update the case status 
     */
     
    savecaseStatus(){
       this._caseService.saveCaseStatus(this.userId,this.caseno, (result) => {                              
          //console.log("***************"+result)
            if(result=="CLOSED_SUCCESSFULLY"){
                location.reload();
            } else {
                this.showError = true;
                this.showerrorMess = "Something went wrong !!"
            }
        })  
    }
    
       /**
     * @author Anand
     * @uses    Print the case details
     */

   printOwner(printSectionId: string){
       
        if(!jQuery(".collapse").hasClass('in')){
        let seeTransaction:HTMLElement = document.getElementById('seeTansactionHistory') as HTMLElement;
        seeTransaction.click();
        }
        let popupWinindow;
        let innerContents = document.getElementById(printSectionId).innerHTML;
        popupWinindow = window.open('', '_blank');
        popupWinindow.document.open();
        popupWinindow.document.write('<html><head> <link rel="stylesheet" type="text/css" href="../../assets/bootstrap/css/bootstrap.css"> </head><body onload="window.print()">' + innerContents + '</html>');
        popupWinindow.document.close();
        
       
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/cases/components/detail.component.ts